<template>
  <VdIcon
    store="far"
    size="small"
    :name="iconName"
    :class="$style.copyButton"
    :style="{
      color: hasCopyFailed ? 'var(--vd-color-red)' : 'var(--vd-color-blue-default)',
    }"
    @click="handleIdCopy"
  ></VdIcon>
</template>

<script setup lang="ts">
import VdIcon from "@/components/VdIcon/VdIcon.vue";
import { ref, computed } from "vue";

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
});

const isCopied = ref(false);
const hasCopyFailed = ref(false);

const handleIdCopy = async () => {
  navigator.clipboard.writeText(props.id).then(
    () => {
      isCopied.value = true;

      setTimeout(() => {
        isCopied.value = false;
      }, 2 * 1000);
    },
    () => {
      hasCopyFailed.value = true;

      setTimeout(() => {
        hasCopyFailed.value = false;
      }, 2 * 1000);
    }
  );
};

const iconName = computed(() => {
  if (isCopied.value) {
    return "check";
  }

  if (hasCopyFailed.value) {
    return "times";
  }

  return "copy";
});
</script>

<style module>
.copyButton {
  cursor: pointer;

  width: 1rem;
}
</style>
